import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  saveLoadingById: false,
  experiencesLength: 0,
  experiences: [],
  experience: {},
  experienceError: "",
  formError: "",
};

export default function ExperienceReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_EXPERIENCE:
      return { ...state, loading: action.payload };
    case actions.LOADING_EXPERIENCE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_EXPERIENCE:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_EXPERIENCE_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_EXPERIENCE:
      return {
        ...state,
        experiences: action.payload.experiences,
        experiencesLength: action.payload.experiencesLength,
      };
    case actions.GET_EXPERIENCE_BY_ID:
      return {
        ...state,
        experience: action.payload,
      };
    case actions.FORM_FAIL_EXPERIENCE:
      return { ...state, formError: action.payload };
    case actions.EXPERIENCE_FAIL:
      return { ...state, experienceError: action.payload };
    default:
      return state;
  }
}
